module.exports = __webpack_public_path__ + "img/P8_popup_thumb_2_cn.ba57ee6d.png";